import { c as _c } from "react/compiler-runtime";
import { decodeColor } from 'betterplace-utils';
import { CSSProperties } from 'react';
import TrustedHtml from '@/components/TrustedHtml';
function WidgetHeadline(t0) {
  const $ = _c(12);
  const {
    content,
    style,
    className,
    headlineFont,
    headlineFontWeight,
    headlineFontSize,
    headlineFontColor
  } = t0;
  if (!content || content.length === 0 || content === "false") {
    return null;
  }
  const t1 = `headline ${className} ${style?.fontStyle === "italic" ? "italic-heading" : ""}`;
  const t2 = headlineFontSize && `${headlineFontSize}px`;
  let t3;
  if ($[0] !== headlineFontColor) {
    t3 = decodeColor(headlineFontColor);
    $[0] = headlineFontColor;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== headlineFont || $[3] !== headlineFontWeight || $[4] !== style || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      ...style,
      "--streambot-headline-font": headlineFont,
      "--streambot-headline-font-weight": headlineFontWeight,
      "--streambot-headline-font-size": t2,
      "--streambot-headline-font-color": t3,
      "padding": 0
    };
    $[2] = headlineFont;
    $[3] = headlineFontWeight;
    $[4] = style;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = t4 as CSSProperties;
  let t6;
  if ($[8] !== content || $[9] !== t1 || $[10] !== t5) {
    t6 = <><TrustedHtml value={content} as="div" className={t1} style={t5} /></>;
    $[8] = content;
    $[9] = t1;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
export default WidgetHeadline;